import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    relatedUser: PropTypes.object.isRequired,
    messageGroupId: PropTypes.number.isRequired,
    messageGroupsUserIds: PropTypes.array.isRequired,
    loadMessageListFromServer: PropTypes.func,
    loadRelatedUsersFromServer: PropTypes.func,
  },
  getInitialState() {
    return {
      relatedUser: this.props.relatedUser,
    };
  },
  handleAddUserToMessageGroup: function() {
    $.ajax({
      url: "/api/message/add_user_to_message_group",
      type: "POST",
      data: {
        message_group_id: this.props.messageGroupId,
        user_id: this.state.relatedUser.id,
      },
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      success: function(data) {
        if (data === "success") {
          this.props.loadMessageListFromServer();
          this.props.loadRelatedUsersFromServer();
        }
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  render() {
    var user = this.state.relatedUser;
    var userBox = "";
    var member_url = "/member/profile/" + this.state.relatedUser.member_id;
    if (
      user.avatar_thumb &&
      this.props.messageGroupsUserIds.indexOf(user.id) == -1
    ) {
      userBox = (
        <li>
          <label>
            <a href={member_url}>
              <img
                src={user.avatar_thumb}
                style={{ width: "32px", height: "32px" }}
              />&nbsp;
              {user.familyname}
              {user.firstname}
            </a>
            &nbsp;&nbsp;<a onClick={this.handleAddUserToMessageGroup}>
              <i className="fas fa-plus-circle" />
            </a>
          </label>
        </li>
      );
    }
    return <div>{userBox}</div>;
  },
});
